import { Link } from "react-router-dom";
import { LockIcon, GreenCheckIcon, CircleIcon } from "../assets/icons";

const TimelineItem = ({
  title,
  link,
  status = "locked", // locked, completed, available
  isLast = false,
}) => {
  const getStatusIcon = () => {
    switch (status) {
      case "completed":
        return (
          <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center text-white">
            <GreenCheckIcon className="h-5 w-5" />
          </div>
        );
      case "locked":
        return (
          <div className="w-6 h-6 rounded-full bg-transparent flex items-center justify-center text-white">
            <LockIcon className="h-6 w-6 fill-lz-ember dark:fill-lz-candle" />
          </div>
        );
      case "available":
        return <CircleIcon />;
      default:
        return null;
    }
  };

  return (
    <div className="flex items-start">
      {/* Icon */}
      <div className="flex flex-col items-center">
        {getStatusIcon()}
        {!isLast && (
          <div className="w-0.5 h-6 mt-2 bg-gray-300 dark:bg-gray-600"></div>
        )}
      </div>

      {/* Content */}
      <div className="ml-4">
        {status !== "locked" ? (
          <Link
            to={link}
            className="text-lg dark:text-lz-candle text-lz-ember hover:underline"
          >
            {title}
          </Link>
        ) : (
          <span className="text-lg dark:text-lz-candle text-lz-ember">
            {title}
          </span>
        )}
      </div>
    </div>
  );
};

export default TimelineItem;
